<template>
  <v-dialog v-model="dialogVisible" max-width="400" persistent>
    <v-card>
      <v-card-title class="text-h6">
        Prorrogar vigência da cotação
      </v-card-title>

      <v-card-text>
        <p class="text-body-2 mb-4">
          Defina a nova data e hora de término da cotação.
        </p>

        <v-text-field
          v-model="newDeadlineDate"
          v-mask="'##/##/####'"
          label="Término"
          placeholder="dd/mm/aaaa"
          outlined
          dense
          hide-details="auto"
          class="mb-3"
        ></v-text-field>

        <v-text-field
          v-model="newDeadlineTime"
          v-mask="'##:##'"
          label="Hora"
          placeholder="HH:mm"
          outlined
          dense
          hide-details="auto"
        ></v-text-field>
      </v-card-text>

      <v-card-actions class="px-6 pb-4">
        <v-btn
          text
          color="primary"
          class="text-capitalize"
          @click="handleClose"
        >
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="text-capitalize"
          elevation="0"
          @click="handleSave"
        >
          Salvar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import useProrrogarVigenciaDialog from '../composables/useProrrogarVigenciaDialog';

const props = defineProps({
  visible: { type: Boolean, required: true },
  idCotacao: { type: Number, default: null },
  currentDeadline: { type: String, default: '' },
  handleClose: { type: Function, required: true },
  onSuccess: { type: Function, default: () => {} }
});

const {
  newDeadlineDate,
  newDeadlineTime,
  dialogVisible,
  handleSave
} = useProrrogarVigenciaDialog(props);
</script>
